var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "row-sm": "", wrap: "" } },
        [
          _vm.shouldShowDropBox
            ? _c(
                "div",
                {
                  staticClass: "drag-drop-image",
                  on: {
                    drop: _vm.dropFiles,
                    dragenter: _vm.checkDrop,
                    dragover: _vm.checkDrop,
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "close-button" },
                    [
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.closeDropBox()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("cancel")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "h2",
                    [
                      _c("v-icon", [_vm._v("file_upload")]),
                      _vm._v(" Drag your images here to upload"),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-card-title",
                    [_c("v-icon", [_vm._v("upload")]), _vm._v(" Upload")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-expansion-panels",
                        {
                          attrs: { multiple: "" },
                          model: {
                            value: _vm.openPanels,
                            callback: function ($$v) {
                              _vm.openPanels = $$v
                            },
                            expression: "openPanels",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", [
                                _c(
                                  "b",
                                  [
                                    _c("v-icon", [_vm._v("cloud_upload")]),
                                    _vm._v(" Upload New Images"),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { fluid: "" } },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "4",
                                              },
                                            },
                                            [
                                              _c(
                                                "fieldset",
                                                [
                                                  _c("legend", [
                                                    _vm._v(
                                                      "Photos From Your Device"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-file-input", {
                                                    attrs: {
                                                      "hide-details": "",
                                                      dense: "",
                                                      outlined: "",
                                                      label: "Upload files",
                                                      accept: "image/jpeg",
                                                      multiple: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.imageFileSelected(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.selectedFiles.length
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "mt-4" },
                                                        [
                                                          _c(
                                                            "v-card-text",
                                                            {
                                                              staticClass:
                                                                "pa-0",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Selected Files:"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.selectedFiles,
                                                            function (
                                                              file,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "v-chip",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "ma-1",
                                                                  attrs: {
                                                                    close: "",
                                                                  },
                                                                  on: {
                                                                    "click:close":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeFile(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      file.file
                                                                        .name
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6",
                                                md: "8",
                                              },
                                            },
                                            [
                                              _c(
                                                "fieldset",
                                                [
                                                  _c("legend", [
                                                    _vm._v("Properties"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              dense: "",
                                                              outlined: "",
                                                              items:
                                                                _vm.imageTypes,
                                                              label:
                                                                "Image Type",
                                                              "item-text":
                                                                "text",
                                                              "item-value":
                                                                "value",
                                                              id: "image-type",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.allImages
                                                                  .imageType,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.allImages,
                                                                    "imageType",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "allImages.imageType",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              dense: "",
                                                              outlined: "",
                                                              label: "Caption",
                                                              name: "caption",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.allImages
                                                                  .caption,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.allImages,
                                                                    "caption",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "allImages.caption",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.selectedFiles.length <
                                                      2
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    "hide-details":
                                                                      "",
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "Description",
                                                                    name: "description",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .allImages
                                                                        .description,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.allImages,
                                                                          "description",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "allImages.description",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.selectedFiles.length <
                                                      2
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    "hide-details":
                                                                      "",
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    label:
                                                                      "Copyright Information",
                                                                    name: "copyright",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .allImages
                                                                        .copyright,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.allImages,
                                                                          "copyright",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "allImages.copyright",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-checkbox", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              dense: "",
                                                              label:
                                                                "Display in Slideshows",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.allImages
                                                                  .display_slideshow,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.allImages,
                                                                    "display_slideshow",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "allImages.display_slideshow",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              dense: "",
                                                              outlined: "",
                                                              label:
                                                                "Sort Order in Slideshows",
                                                              name: "sort_order",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.allImages
                                                                  .sort_order,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.allImages,
                                                                    "sort_order",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "allImages.sort_order",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "fieldset",
                                                [
                                                  _c("legend", [
                                                    _vm._v("Relationships"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-row",
                                                    { attrs: { wrap: "" } },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.shouldShowHotelPicker,
                                                              expression:
                                                                "shouldShowHotelPicker",
                                                            },
                                                          ],
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "ies-hotel-and-room-key",
                                                            {
                                                              attrs: {
                                                                field:
                                                                  _vm.selectRoomField,
                                                                configuration:
                                                                  '{"shouldEmitOnSelect":true, "selectHotelEventName":"Image Uploader: select hotel", "selectRoomEventName": "Image Uploader: select room type"}',
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.shouldShowRegionPicker,
                                                              expression:
                                                                "shouldShowRegionPicker",
                                                            },
                                                          ],
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              dense: "",
                                                              outlined: "",
                                                              label: "Region",
                                                              items:
                                                                _vm.regions,
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.regionChosen,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.allImages
                                                                  .region_key,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.allImages,
                                                                    "region_key",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "allImages.region_key",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "mt-2",
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.allImages
                                                                    .region_key,
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.clearRegion,
                                                              },
                                                            },
                                                            [_vm._v("Clear")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              dense: "",
                                                              outlined: "",
                                                              label: "Trip",
                                                              items: _vm.trips,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.allImages
                                                                  .trip_key,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.allImages,
                                                                    "trip_key",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "allImages.trip_key",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "mt-2",
                                                              attrs: {
                                                                disabled:
                                                                  !_vm.allImages
                                                                    .trip_key,
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.clearTrip,
                                                              },
                                                            },
                                                            [_vm._v("Clear")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ies-green",
                                                  on: {
                                                    click: _vm.uploadToLibrary,
                                                  },
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("save"),
                                                  ]),
                                                  _vm._v(" Save"),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }